/* eslint-disable no-undef */
import { FunctionComponent } from 'react';
import CourseLanding from './../../components/courseLanding';
import SectionTitle from './../../components/sectionTitle';
import Conversation from './conversation';
import Conversations from './conversations';
import Animation004 from './animation004';
import Animation006 from './animation006';
import Animation008 from './animation008';
import Animation016 from './animation016';
import Animation020 from './animation020';
import Animation021 from './animation021';
import Animation022 from './animation022';
import Animation025 from './animation025';
import Animation026 from './animation026';
import Animation027 from './animation027';
import Animation030 from './animation030';
import Animation031 from './animation031';
import Animation032 from './animation032';
import Animation033 from './animation033';
import Animation034 from './animation034';
import Quiz from './../../components/quiz';
import Component002 from './component002';
import Component003 from './component003';
import Component004 from './component004';
import Component005 from './component005';
import Component008 from './component008';

const Components: {
  [key: string]: FunctionComponent<any>;
} = {
  Quiz,
  CourseLanding,
  SectionTitle,
  Conversation,
  Conversations,
  Animation004,
  Animation006,
  Animation008,
  Animation016,
  Animation020,
  Animation021,
  Animation022,
  Animation025,
  Animation026,
  Animation027,
  Animation030,
  Animation031,
  Animation032,
  Animation033,
  Animation034,
  Component002,
  Component003,
  Component004,
  Component005,
  Component008,
};

export default Components;
